import type { FirebaseWebConfig } from '@/api/types';

/**
 * The built-in public Firebase Web config (the tilework project), bundled into
 * the client so the `/signin` flow initializes the Firebase SDK with no
 * per-registrar configuration. These identifiers are non-secret — they only
 * name the project to Google's APIs, and authorization is enforced by Firebase
 * (Security Rules, App Check, authorized domains) rather than by keeping them
 * hidden — so shipping them in the client bundle is expected.
 */
export const FIREBASE_WEB_CONFIG: FirebaseWebConfig = {
  apiKey: 'AIzaSyC54HqlGrkyANVFKGDQi3LobO5moDOuafk',
  authDomain: 'tilework-e18c5.firebaseapp.com',
  projectId: 'tilework-e18c5',
  appId: '1:199991289749:web:d7ac38af24e1f29251f89c',
  messagingSenderId: '199991289749',
  storageBucket: 'tilework-e18c5.firebasestorage.app',
  measurementId: 'G-3YXYKJK38T',
};
